<template>
	<div class="footer" v-show="showFooter">
		<div class="footer-content">
			<div class="footer-content-left">
				<img :src="config.logo" style="width: 100px;margin-left: -3px;"> </img>
				<div>
					<div>联系电话</div>
					<div class="phone" style="margin-top: 10px;"> {{ footer.phone }}</div>
				</div>
				<div>
					<div>分支机构</div>
					<div class="info" style="margin-top: 10px;"> {{ config.orgInfo }}</div>
				</div>
				<div>
					<el-tooltip v-for="(item, index) in footer.footerIcon" :key="item" effect="dark" placement="top">
						<img :src="item" class="icon"></img>
						<template #content>
							<div v-if="index == 0" style="padding: 14px;background-color: black;color: white;">
								jingzaiguanwang@enocare-china.com
							</div>
							<img v-else :src="footer.footerHoverImg[index - 1]"
								style="padding: 14px;background-color: black;">
						</template>
					</el-tooltip>
				</div>
			</div>

			<div class="footer-content-right">
				<div v-for="item in footer.footerMenu" :key="item.title">
					<div class="right-title">{{ item.title }}</div>
					<div v-for="child in item.children" :key="child.title" class="right-item"
						@click="toPage(child.url)">
						{{ child.title }}
					</div>
				</div>
			</div>
		</div>
		<div class="footer-bottom">
			<div class="h5_bottom">
				{{ footer.footerInfo }}
			</div>
		</div>
		<div class="footer-bottom1">
			<div>
				沪ICP备19026129号 | ©Copyright 2019-2026
			</div>
			<div>
				上海敬在信息技术有限公司 版权所有
			</div>
		</div>
	</div>
</template>
<script>
import { config } from "../../constant/config.js";
import { menu } from "../../constant/menu.js";
import { toPage } from '@/utils/index.js'
export default {
	name: "enoFooter",
	data() {
		return {
			config: config,
			footer: config.footer,
			showFooter: false,
		};
	},
	mounted() {
		setTimeout(() => {
			this.showFooter = true;
		}, 1000);
	},
	methods: {
		toPage
	},
};
</script>
<style lang="less" scoped>
@bgColor1: #2E2E38;
@bgColor2: #575765;
@white: #FFFFFF;
@fontColor1: #ABABAF;

.childEl1 {
	height: 28px;
}

.footer {
	height: 518px;
	display: flex;
	flex-direction: column;
	color: @white;
	font-size: 14px;

	.footer-content {
		height: 100%;
		padding: 60px;
		background-color: @bgColor1;
		display: flex;
		justify-content: space-between;

		.footer-content-left {
			width: 30%;

			div {
				margin-top: 25px;
			}

			.phone {
				font-size: 24px;
				color: @fontColor1;
				font-weight: 600;
			}

			.info {
				color: @fontColor1;

			}

			.icon {
				margin-right: 12px;
				background-color: @bgColor2;
				width: 32px;
				height: 32px;
				border-radius: 50%; // 可选，和右侧圆角一致
				filter: invert(1);
				object-fit: contain;
				cursor: pointer;
			}
		}

		.footer-content-right {
			width: 60%;
			/* display: flex;
			justify-content: space-around; */
			display: grid;
			grid-template-columns: repeat(4, 1fr);

			.right-title {
				font-size: 16px;
				margin-bottom: 30px;
				font-weight: 500;
			}

			.right-item {
				color: @fontColor1;
				margin: 8px 0;
				font-weight: 400;
				cursor: pointer;

				&:hover {
					text-decoration: underline;
				}
			}
		}
	}

	.footer-bottom {
		height: 64px;
		line-height: 64px;
		text-align: center;
		background-color: @bgColor2 ;
	}

	.footer-bottom1 {
		display: none;
	}
}


// ============ 新增：移动端媒体查询样式 ============
@media @mobile {
	.footer {
		height: auto; // 高度自适应
		font-size: 13px;

		.footer-content {
			padding: 30px 20px; // 缩小内边距
			flex-direction: column; // 改为垂直布局

			.footer-content-left {
				width: 100%;
				margin-bottom: 1px;

				div {
					margin-top: 14px;
				}

				img {
					width: 120px; // 缩小logo
				}

				.phone {
					font-size: 20px; // 缩小电话字体
				}

				.icon {
					width: 28px;
					height: 28px;
				}
			}

			// 暂时隐藏菜单
			.footer-content-right {
				display: none;
			}
		}

		.footer-bottom {
			display: none;
		}

		.footer-bottom1 {
			background-color: @bgColor1;
			font-size: 12px;
			display: block;
			color: #FFFFFF;
			padding: 16px;
		}
	}
}
</style>
